export default __webpack_public_path__ + "static/media/DetailKuisImg.95af5970.png";